<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.confirmModal.' + title | translate: titleArgs }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <div class="width">
      @if (bodyText) {
        <p>{{ 'components.confirmModal.' + bodyText | translate }}</p>
      }
    </div>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" (click)="onConfirm()" type="button">
      {{ 'components.confirmModal.' + confirmText | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.confirmModal.' + denyText | translate }}
    </button>
  </div>
</ng-template>
